module.exports = __webpack_public_path__ + "img/base_activites_en_famille.ab969b8f.svg";